import { BodyText, FlexRow, HashLength } from '@make-software/cspr-design';
import React from 'react';
import { Deploy } from '@block-explorer/entities';
import { ContractIdentifier, HashFontSize } from '../../../components';

const DeployActionDefault = ({ deploy }: { deploy: Deploy }) => {
  const hasContractName = Boolean(
    deploy.contractPackage.name || deploy.contractPackage.contract_name
  );

  return (
    <FlexRow align={'center'} itemsSpacing={8}>
      <BodyText monotype size={3} wordBreak variation={'black'}>
        {deploy.entryPoint?.name}
      </BodyText>
      <BodyText variation={'darkGray'} size={3}>
        with
      </BodyText>
      <ContractIdentifier
        hash={deploy.contractPackage.contract_package_hash}
        contractPackage={deploy.contractPackage}
        avatarSize={'small'}
        hashFontSize={HashFontSize.big}
        hashLength={hasContractName ? HashLength.FULL : HashLength.TINY}
      />
    </FlexRow>
  );
};

export default DeployActionDefault;
